import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Radio } from "@circle-react-uikit/Radio";
import { Typography } from "@circle-react-uikit/Typography";

export interface RadioOptionProps {
  id: string;
  title: string;
  subtitle?: string;
  value: string;
  isSelected: boolean;
}
export const RadioOption = ({
  id,
  title,
  subtitle,
  value,
  isSelected,
}: RadioOptionProps) => (
  <label
    className={classNames("mb-0 p-4 first:rounded-t-xl last:rounded-b-xl", {
      "bg-secondary": isSelected,
    })}
    htmlFor={id}
  >
    <Radio
      id={id}
      value={value}
      labelWrapperClassName="w-full"
      labelClassName="flex flex-col gap-y-1 w-full"
      label={
        <>
          <div className="flex flex-row justify-between">
            <Typography.LabelSm weight="bold" color="text-primary">
              {title}
            </Typography.LabelSm>
            <Typography.LabelSm weight="regular">{value}</Typography.LabelSm>
          </div>
          {title && subtitle ? (
            <Typography.LabelXs weight="medium" color="text-default">
              {subtitle}
            </Typography.LabelXs>
          ) : null}
        </>
      }
      checked={isSelected}
      name="paywall_price_id"
    />
  </label>
);
